// extracted by mini-css-extract-plugin
module.exports = {"statusWrap":"SurveyTable_statusWrap__2HeFe","status":"SurveyTable_status__eTCS2"};